// extracted by mini-css-extract-plugin
export default {"betaBadge":"McpIntegration_betaBadge__Nq27g"};